/**
 * Canonical inherent risk tier definition.
 *
 * Shared across services and the frontend so the four-tier vocabulary
 * stays in one place — values and the derived union type.
 */
export const INHERENT_RISK_TIERS = ['Low', 'Medium', 'High', 'Critical'] as const

export type InherentRiskTier = (typeof INHERENT_RISK_TIERS)[number]

export const INHERENT_RISK_TIER_THRESHOLDS: Record<InherentRiskTier, number> = {
  Low: 2,
  Medium: 3,
  High: 4,
  Critical: 5,
}

const TIERS_ASCENDING = Object.entries(INHERENT_RISK_TIER_THRESHOLDS) as [InherentRiskTier, number][]

export const inherentRiskTierForScore = (score: number): InherentRiskTier =>
  TIERS_ASCENDING.find(([, threshold]) => score <= threshold)?.[0] ?? 'Critical'
